import { render, staticRenderFns } from "./rp-attr-filter-header.vue?vue&type=template&id=1d84baa6"
import script from "./rp-attr-filter-header.vue?vue&type=script&lang=js"
export * from "./rp-attr-filter-header.vue?vue&type=script&lang=js"
import style0 from "./rp-attr-filter-header.vue?vue&type=style&index=0&id=1d84baa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports